
import { useStore } from '@/store'
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import Logo from './Logo.vue'
import SidebarItem from './SidebarItem.vue'
// import _variables from '../../../styles/variables.scss'

export default defineComponent({
  name: 'Sidebar',
  components: { Logo, SidebarItem },
  setup () {
    const store = useStore()
    const permRoutes = computed(() => {
      const routes = []
      console.log(store.state.permission.routes)
      for(let i = 0,len = store.state.permission.routes.length;i<len;i++){
          if(store.state.permission.routes[i].hidden!=true)
          {
            routes.push(store.state.permission.routes[i])
          }
      }
      console.log(routes)
      return routes
    }
    )

    const activeMenu = computed(() => {
      const route = useRoute()
      const { meta, path } = route
      if (meta.activeMenu) return meta.activeMenu
      return path
    })

    const isCollapse = computed(() => !store.state.app.sidebar.opened)

    // console.log(_variables, 878)

    return {
      permRoutes,
      activeMenu,
      isCollapse,
      variables: {
        menuBg: '#304156',
        menuText: '#bfcbd9',
        menuActiveText: '#409EFF'
      }
    }
  }
})
